import React from "react";

import Input from "./components/Input";
import Weather from "./components/Weather";

import convertToFlag from "./utils/convertToFlag";

class App extends React.Component {
  state = {
    search: "",
    isLoading: false,
    displayCountry: "",
    weather: {},
  };

  handleFetch = async () => {
    if (this.state.search.length < 3) {
      this.setState({ weather: {} });
      return;
    }

    this.setState({ isLoading: true });

    try {
      // 1) Getting location (geocoding)
      const geoRes = await fetch(
        `https://geocoding-api.open-meteo.com/v1/search?name=${this.state.search}`,
      );
      const geoData = await geoRes.json();

      if (!geoData.results) throw new Error("Location not found");

      const { latitude, longitude, timezone, name, country_code } =
        geoData.results.at(0);
      this.setState({
        displayCountry: `${name} ${convertToFlag(country_code)}`,
      });

      // 2) Getting actual weather
      const weatherRes = await fetch(
        `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&timezone=${timezone}&daily=weathercode,temperature_2m_max,temperature_2m_min`,
      );
      const weatherData = await weatherRes.json();
      this.setState({ weather: weatherData.daily });
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleSearchChange = (e) => this.setState({ search: e.target.value });

  componentDidMount() {
    this.setState({ search: localStorage.getItem("search") || "" });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.search !== prevState.search) this.handleFetch();
    localStorage.setItem("search", this.state.search);
  }

  render() {
    return (
      <div className="app">
        <h1>Classy Weather App</h1>
        <div>
          <Input
            search={this.state.search}
            handleSearchChange={this.handleSearchChange}
          />
        </div>
        {this.state.isLoading && <p className="loader">Loading...</p>}

        {this.state.weather.weathercode && (
          <Weather
            location={this.state.displayCountry}
            weatherData={this.state.weather}
          />
        )}
      </div>
    );
  }
}

export default App;
